export default "<div class=\"loading\">Loading...</div>"